import { render } from "./ChosenField.vue?vue&type=template&id=20063ebc"
import script from "./ChosenField.vue?vue&type=script&lang=js"
export * from "./ChosenField.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__